import React from 'react'
import { withRouter } from 'react-router-dom'

import SVGLayer from './SVGLayer'
import Description from './Description'
import LayerContent from '../../LayerContent'

const SurfaceWater = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) => (
        <div className={`layer layer--pools`}>
          <SVGLayer active={active} setActiveProject={setActiveProject} />
        </div>
      )}
    </LayerContent>
  )
}

export { Description as SurfaceWaterDescription }
export default withRouter(SurfaceWater)
